module.exports = __webpack_public_path__ + "img/show_more.aeef5394.png";